<template>
  <div class="launch-all" @click="launchClick">
    <div v-if="launchStatus">
      <span>展开</span>
      <i class="el-icon-arrow-down"></i>
    </div>
    <div v-else>
      <span>收起</span>
      <i class="el-icon-arrow-up"></i>
    </div>

    <!-- <input :type="type" :value="value" :placeholder="placeholder" @input="handleInput" /> -->
  </div>
</template>

<script>
export default {
  name: "launchSelect",
  data() {
    return {
      launchStatus: true,
    };
  },
  //   props: {
  //     launchStatus: {
  //       type: Boolean,
  //       default: false,
  //     },
  //   },

  methods: {
    launchClick() {
      this.launchStatus = !this.launchStatus;
      this.$emit("launchStatusChang", this.launchStatus);
    },
  },
};
</script>

<style lang="less" scoped>
.launch-all {
  display: inline-block;
  color: #846ffd;
  font-size: 16px;
  margin: 0 20px 10px 0;
  cursor: pointer;
}
//   .input-all {
//     display: flex;
//     padding-left: 27px;
//     align-items: center;

//     width: 415px;
//     height: 60px;
//     background: #ffffff;
//     border-radius: 30px;

//     input {
//       outline: none;
//       border: none;
//       font-size: 18px;
//       font-weight: 300;
//       width: 100%;
//       height: 100%;
//       border-radius: 30px;
//       background-color: transparent;
//       &::placeholder {
//         color: #999fb5;
//         line-height: 25px;
//       }

//       // 解决chrome自动填充含有背景色
//       &:-webkit-autofill {
//         box-shadow: 0 0 0 1000px #fff inset;
//       }
//     }
//   }
</style>
